import initOptinStartSwiper from './views/moment-carousel'

import './index.scss'

const bridge = (window as any).MP

const fitScreenToViewPort = e => {
  const viewportHeightInVH = window.innerHeight
  // We're leaving this logging for an indeterminate amount of time until
  // we are confident a bug in android changing the size of the viewport
  // during load is no longer an issue.
  console.log(e)
  console.log(e.type)
  console.log(viewportHeightInVH)
  const mainContainer: any = document.querySelector('.opt-in')
  mainContainer.style.setProperty('height', `${viewportHeightInVH}px`)
}

const onAccept = () => {
  if (bridge.optinAccept) {
    bridge.optinAccept()
  } else {
    bridge.optUserIn(!0)
    bridge.launchClient()
    bridge.dismiss(false)
  }
}

const onDecline = () => {
  if (bridge.optinDismiss) {
    // Despite the bridge method name indicating dismissal, this button serves
    // to decline the app
    bridge.optinDismiss()
  } else {
    bridge.dismiss(false)
  }
}

const initOptinStartMoment = () => {
  try {
    const optinType = document.documentElement.getAttribute('data-opt-in-type')
    if (optinType === 'moment-carousel') {
      initOptinStartSwiper()
    }
  } catch (e) {
    console.error('Optin Start Moment init error ', e)
  }
}

const onDOMContentLoaded = () => {
  const acceptButton = document.querySelector('#accept_tos')

  if (acceptButton instanceof HTMLButtonElement) {
    acceptButton.addEventListener('click', onAccept)
  }

  // Only Cricket has a button to dismiss.
  const declineButton = document.querySelector('#decline_tos')
  if (declineButton) {
    declineButton.addEventListener('click', onDecline)
  }

  initOptinStartMoment()
}

window.addEventListener('DOMContentLoaded', onDOMContentLoaded)
window.addEventListener('load', fitScreenToViewPort)
window.addEventListener('resize', fitScreenToViewPort)
